export const toDvhWithVhFallback = (value: number): string =>
  `min(${value}dvh, ${value}vh)`;

export const KEYBOARD_OPEN_SHEET_HEIGHT_RATIO = 0.9;

export interface VisualViewportBounds {
  offsetTop: number;
  offsetLeft: number;
  width: number;
  height: number;
}

export interface BottomSheetHeightOptions {
  keyboardInset?: number;
  keyboardOpenHeightRatio?: number;
}

export const getMobileListHeightStyle = (
  subtractPx: number
): { maxHeight: string } => ({
  maxHeight: `calc(${toDvhWithVhFallback(80)} - ${subtractPx}px)`
});

export const getBottomSheetMaxHeight = (
  availableHeight: number | null,
  layoutHeight: number,
  options: BottomSheetHeightOptions = {}
): string => {
  const {
    keyboardInset = 0,
    keyboardOpenHeightRatio = KEYBOARD_OPEN_SHEET_HEIGHT_RATIO
  } = options;
  const maxDvh = toDvhWithVhFallback(80);

  if (availableHeight === null) {
    return maxDvh;
  }

  if (keyboardInset > 0) {
    return `${Math.floor(availableHeight * keyboardOpenHeightRatio)}px`;
  }

  const cappedAvailable = Math.min(availableHeight, layoutHeight * 0.8);
  return `min(${maxDvh}, ${cappedAvailable}px)`;
};

export const getVisualViewportBounds = (
  visualViewport: VisualViewport | null | undefined,
  layoutWidth: number,
  layoutHeight: number
): VisualViewportBounds | null => {
  if (!visualViewport) {
    return null;
  }

  return {
    offsetTop: visualViewport.offsetTop,
    offsetLeft: visualViewport.offsetLeft,
    width: visualViewport.width || layoutWidth,
    height: visualViewport.height || layoutHeight
  };
};

export const getKeyboardInset = (
  layoutHeight: number,
  visualViewport: VisualViewport | null | undefined
): number => {
  if (!visualViewport) {
    return 0;
  }

  return Math.max(
    0,
    layoutHeight - (visualViewport.height + visualViewport.offsetTop)
  );
};

export const isMobileViewport = (
  deviceWidth: number,
  mobileBreakpoint: number
): boolean => mobileBreakpoint > 0 && deviceWidth <= mobileBreakpoint;

export const isNodeInsideBottomSheet = (target: Node | null): boolean => {
  if (!(target instanceof Element)) {
    return false;
  }

  return Boolean(target.closest('.base__bottom__sheet'));
};
